// Imports
import React, { Fragment } from 'react';

// Hooks
import { useSelector } from 'react-redux';

// Views
import WorkOrdersMainView from './views/main';
import WorkOrdersCustomerDetail from './views/customerDetail';
// Utils
import { HasPermission } from '../../core/security';

// Router
import { Routes, Route, Navigate } from 'react-router-dom';

const workOrderManage = () => {
    
    const user = useSelector(state => state.securityRedux.user);
    
    return (
        <Routes>
            {
                HasPermission(user, "workorders", [288]) &&
                <Fragment>
                    <Route path='/' element={<Navigate to="/app/workorders/main" />}></Route>
                    <Route path='main' element={<WorkOrdersMainView />} />
                    <Route path='customerDetail/:id' element={<WorkOrdersCustomerDetail />} />
                </Fragment>
            }
            <Route path="*" element={<Navigate to="/app/error" />} />
        </Routes>
    );
};

export default workOrderManage